// The rail is full (labels) from standard_desktop, icon-only from tablet, and a drawer below tablet.
export const NAV_RAIL_FULL_WIDTH = 236;
export const NAV_RAIL_ICON_WIDTH = 76;

// For fixed elements spanning the page (footers): start at the rail's right edge instead of under it.
export const clearNavRail = (theme) => ({
  [`@media (min-width: ${theme.screens.tablet}px)`]: {
    left: NAV_RAIL_ICON_WIDTH,
    width: `calc(100% - ${NAV_RAIL_ICON_WIDTH}px)`
  },
  [`@media (min-width: ${theme.screens.standard_desktop}px)`]: {
    left: NAV_RAIL_FULL_WIDTH,
    width: `calc(100% - ${NAV_RAIL_FULL_WIDTH}px)`
  }
});
